import { getRequiredFields } from 'util/getZodSchemaRequiredFields'
import { z } from 'zod'

export const TextFormSchema = z.object({
	uuid: z.string().trim(),
})

export const requiredFormFields = getRequiredFields(TextFormSchema)

export type TextFormInputs = z.infer<typeof TextFormSchema> & any //TODO: REMOVE ANY
